import { useContext } from 'react';

import { DalContext } from '@/contexts/dalContext';

export const useDAL = () => {
  const context = useContext(DalContext);

  if (!context) {
    throw new Error('useDAL must be used within a DalProvider');
  }

  return context;
};
